const PUNDIT_NOT_AUTHORIZED_MESSAGE =
  'You\'re not authorized to take this action. Please contact your administrator.'

// Bones sends session-token failures as 401 (403 on older deployments) with a JWT_* code
function isJwtSessionError({ status, data }) {
  return (status === 401 || status === 403) && data?.code?.startsWith('JWT_')
}

export default function (context) {
  const { $axios, store, redirect } = context

  $axios.defaults.xsrfCookieName = 'CSRF-TOKEN'
  $axios.defaults.xsrfHeaderName = 'X-CSRF-Token'
  $axios.defaults.headers.common['GLEANIN-FE-VERSION'] = process.env.buildHash

  $axios.interceptors.response.use(
    (response) => {
      if (response.headers['gleanin-fe-version']) {
        const version = response.headers['gleanin-fe-version']
        if (version !== process.env.buildHash) {
          store.dispatch('app/showNewVersionAvailable')
        }
      }
      return response
    },
    (error) => {
      const { response } = error
      let message = null

      if (!response) {
        message = [
          'The request to the server failed, please check your internet connection.',
          'This can also be caused by your network security settings.',
          'Please contact hello@gleanin.com if the issue persists.',
        ].join(' ')
      } else if (isJwtSessionError(response)) {
        if (!window.location.href.includes('/login')) {
          localStorage.setItem('gleaninSessionInvalidated', response.data.error)
          window.location.href = '/login'
        }

        return Promise.resolve({ data: [] })
      } else if (response.status === 401) {
        message = PUNDIT_NOT_AUTHORIZED_MESSAGE

        const responseText = response.request.responseText
        if (responseText) {
          const jsonResponse = JSON.parse(responseText)
          if (jsonResponse.errors) {
            message = jsonResponse.errors.join('. ')
          }
        }
      } else if (response.status >= 500) {
        if (response.status === 503) {
          if (response?.data?.message) {
            store.dispatch('app/setMaintenanceMessage', response.data.message)
          }
          return redirect('/maintenance')
        }
        message = 'Something went wrong.'
      } else if (response.status === 403) {
        const { data } = response

        message = PUNDIT_NOT_AUTHORIZED_MESSAGE
        if (data?.errors) {
          message = data.errors.join('. ')
        } else if (data?.error) {
          message = data.error
        }
      }

      if (message) {
        store.dispatch('app/showError', { error: { message } })
      }

      return Promise.reject(error)
    }
  )
}
